import type { ComponentProps, FC } from "react"

import { animated } from "@react-spring/web"

import { NzeroSymbolLeft } from "../../logo/nzero-symbol-left"
import { NzeroSymbolRight } from "../../logo/nzero-symbol-right"

interface AppSplashProps {
  leftSpring: ComponentProps<typeof animated.div>["style"]
  rightSpring: ComponentProps<typeof animated.div>["style"]
}

export const AppSplash: FC<AppSplashProps> = ({ leftSpring, rightSpring }) => (
  <div
    style={{
      alignItems: "center",
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: 0,
      top: 0,
    }}
  >
    <div
      style={{
        display: "flex",
      }}
    >
      <animated.div style={rightSpring}>
        <NzeroSymbolLeft
          height={112}
          style={{
            transform: "translateY(14px)",
          }}
          width={120.61}
        />
      </animated.div>
      <animated.div style={leftSpring}>
        <NzeroSymbolRight
          height={112}
          style={{
            transform: "translateY(-14px)",
          }}
          width={120.61}
        />
      </animated.div>
    </div>
  </div>
)
